"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = exports.DEFAULT_RETRY_CONDITION = void 0;
const fetchMiddleware_1 = require("./fetchMiddleware");
// see README.md#Retries for considerations
const DEFAULT_RETRY_CONDITION = (ctx) => {
    var _a, _b, _c, _d;
    // it was successful
    if ((_a = ctx.response) === null || _a === void 0 ? void 0 : _a.ok)
        return false;
    // we shouldn't retry other methods then GET as the mutate state and are not necessarily atomic
    if (((_c = (_b = ctx.options) === null || _b === void 0 ? void 0 : _b.method) !== null && _c !== void 0 ? _c : "GET").toUpperCase() !== "GET")
        return false;
    // we shouldn't retry when server returns status, like redirects (3XX), client (4XX) or server (5XX) but also other codes
    // and also we don't want to retry circuit breaker
    // so at the end retry just NETWORK_FAILURE
    return ((_d = ctx.response) === null || _d === void 0 ? void 0 : _d.status) === fetchMiddleware_1.FETCH_ERRORS.NETWORK_FAILURE;
};
exports.DEFAULT_RETRY_CONDITION = DEFAULT_RETRY_CONDITION;
const retry = (ctx, next) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!ctx.options.retry) {
        return next();
    }
    const condition = (_a = ctx.options.retry.condition) !== null && _a !== void 0 ? _a : exports.DEFAULT_RETRY_CONDITION;
    let retry = -1;
    do {
        retry++;
        yield next();
    } while (condition(ctx) && retry < ctx.options.retry.count);
});
exports.retry = retry;
//# sourceMappingURL=retry.js.map